module.exports = __webpack_public_path__ + "static/cloud_giant-23e1da7fc863df6e7d5c230dff0a02d3.jpeg";